import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import Alert from '@mui/material/Alert';
import { useTranslation } from 'react-i18next';

const VARIANT_SEVERITY = {
  success: 'success',
  error: 'error',
  warning: 'warning',
  info: 'info',
};

export default function MessageModal({
  visible,
  onClose,
  title,
  message,
  variant = 'info',
  hideActions = false,
}) {
  const { t } = useTranslation();

  return (
    <Dialog open={visible} onClose={onClose} maxWidth="xs" fullWidth>
      {title && <DialogTitle fontWeight={700}>{title}</DialogTitle>}
      <DialogContent sx={{ pb: hideActions ? 3 : undefined }}>
        {message && (
          <Alert severity={VARIANT_SEVERITY[variant] || 'info'} sx={{ mt: title ? 0 : 1 }}>
            {message}
          </Alert>
        )}
      </DialogContent>
      {!hideActions && (
        <DialogActions sx={{ px: 3, pb: 2 }}>
          <Button variant="contained" fullWidth onClick={onClose}>
            {t('close')}
          </Button>
        </DialogActions>
      )}
    </Dialog>
  );
}
